import urlUtils from "./urlUtils";

import { getPublicConfig } from './config'

export function setDisableExtensions() {
  // 不是内嵌不需要设置
  if (!urlUtils.isEmbeddedLoader()) {
    return;
  }
  // vscode-next 中接收的 window.disableExtensions 是一个 function
  window.parent.disableExtensions = async () => {
    const config = await getPublicConfig();
    const disableExtensions = [];
    if (!config.isTencentCloud) {
      disableExtensions.push('Tencent-Cloud.coding-copilot');
    }
    const metaworkDisableExtensions = config?.metaworkDisableExtensions?.split(',') ?? [];
    if (config.isPartner) {
      disableExtensions.push(...metaworkDisableExtensions);
    }
    return disableExtensions.filter(item => !!item);;
  }
}
